module.exports = __webpack_public_path__ + "media/images/emblems/Gisikon_LU-48c2fbf055c51887b86d7dfbc3b2ffe4.png";